import { IdBuilder } from './../../ts/rlAdmin.utils';
import * as Models from "../../ts/rlAdmin.models";
import * as Consts from "../../ts/rlAdmin.consts";
import * as Utils from "../../ts/rlAdmin.utils";
import { BaseContractController } from "../_baseDealController";
import { EntityService } from "../../services/entity-service";
import { EntityConfigService } from "../../services/entity-config-service"
import { ContractService } from "../../services/contract-service";
import { ContractSharedDataService } from "../../services/contract-shared-data-service";
import { LocalCacheService } from "../../services/local-cache-service";
import { NotifyService } from "../../services/notify-service";
import { EventService } from "../../services/event-service";
import { AdminService } from "../../services/admin-service";
import { AclService } from "../../services/acl-service";
import { SearchService } from "../../services/search-service";
import { VariesByCatalogService } from "../../services/varies-by-catalog-service";
import { IEntitiesSelectedEvent } from "assets/app/components/entity-validation-selector";
import { IMockRelatedEntityResponse } from '../../ts/rlAdmin.models';

export class DealRightsController extends BaseContractController {
	static $inject = ["$scope", "$q", "$timeout", "$window",
		"entityService", "entityConfigService", "contractService", "contractSharedDataService", "localCacheService", "notifyService",
		"eventService", "adminService", "$interval", "aclService", "searchService", "$location", "$anchorScroll", "variesByCatalogService"];

	contractID: string;
	initialized: boolean;
	contractRights: Models.IContractRightDocumentRelationshipPair[];                    // contract rights relationship with entities, lighter weigth
	newRightCharDataCollection: Models.ICharDataCollection;                             // chardata for new rightset modal
	rightTemplates: Models.ICharacteristicTemplate[];                                   // template list for RightSets
	rightSetModalOpen: boolean;                                                         // open flag for create RightSet modal
	selectedEntities: _.Dictionary<Models.IEntitySearchDoc[]> = {};
	assetTitleDictionary: { [key: number]: string };
	assetTitlesSorted: Models.IKeyValuePair<number, string>[];
	showRightAssets: boolean;
	availAssetDictionary: { [key: number]: { [assetID: number]: string } };

	rightAssocSelectedAssetIDs: number[];
	rightAssocCheckAll: boolean;
	loadingAssets: boolean;
	locked: boolean;
	canEdit: boolean;

	forceRefresh: boolean;
	searchNumFound: number;
	searchPage: number;
	searchPageCount: number;
	searchPageSize: number;

	selectedEntityCharData: Models.ICharDataCollection;

	variesByCatalogOpenModal: boolean;
	hasVariesByCatalog: boolean;
	variesByCatalogParentTemplateID: string;
	variesByCatalogCharDataCollection: Models.ICharDataCollection;
	variesByCatalogSelectedAssets: { [key: number]: string };
	newRightsIDs: string[];

	editAssetModalEntitiesRequired: boolean;
	rightsDataDefaults: Models.IDataDefaultSet[];
	newDataDefaultSetEntityIDs: string[];

	dataDefaultLabel: string;
	showSaveDefaultsModal: boolean = false;
	editContactModalEntitiesRequired: boolean;
	relationshipCharTypeIDs: number[];
	relationshipRequired: { [key: string]: boolean } = {};
	selectedContacts: Models.IEntitySearchDoc[];
	templateColors: { [key: number]: string } = {};

	//RRP
	showRelativeRightsProfiles: boolean = false;
	relativeRightsProfiles: Models.IEntitySearchDoc[] = [];
	showAssociateRRPModal: boolean = false;
	targetRRP: Models.IEntitySearchDoc;
	rrpSelectedCatalogItems: Models.IEntitySearchDoc[] = [];
	rrpAdditionalOption: number = 2;
	rrpHasInvalidRightset: boolean = false;
	rrpHasInvalidCatalog: boolean = false;
	rrpRightsTemplates: Models.IGroup[];
	rrpCatalogTemplates: { [templateID: number]: number[] } = [];
	showRRPErrorModal: boolean = false;
	userCanCreateAllRightsOnRRP: boolean = true;

	contractTemplateID: number;
	allowedTemplates: number[];

	constructor(
		$scope: ng.IScope,
		$q: ng.IQService,
		private $timeout: ng.ITimeoutService,
		private $window: ng.IWindowService,
		entityService: EntityService,
		private entityConfigService: EntityConfigService,
		private contractService: ContractService,
		sharedData: ContractSharedDataService,
		localStorage: LocalCacheService,
		notifyService: NotifyService,
		private eventService: EventService,
		adminService: AdminService,
		$interval: ng.IIntervalService,
		private aclService: AclService,
		private searchService: SearchService,
		public $location: ng.ILocationService,
		public $anchorScroll: ng.IAnchorScrollService,
		private variesByCatalogService: VariesByCatalogService) {

		super($scope, entityService, sharedData, localStorage, notifyService, adminService, $interval, $q, $location, $anchorScroll);

		this.contractID = "";
		this.initialized = false;
		this.newRightCharDataCollection = null;
		this.rightTemplates = [];
		this.rightSetModalOpen = false;
		this.assetTitleDictionary = {};
		this.assetTitlesSorted = [];
		this.showRightAssets = false;
		this.availAssetDictionary = {};

		this.rightAssocSelectedAssetIDs = [];
		this.rightAssocCheckAll = false;
		this.loadingAssets = false;
		this.locked = false;
		this.canEdit = false;

		this.contractRights = [];

		this.searchNumFound = 0;
		this.searchPage = 1;
		this.searchPageCount = 1;
		this.searchPageSize = 10;

		this.variesByCatalogOpenModal = false;
		this.hasVariesByCatalog = false;
		this.variesByCatalogSelectedAssets = {};

		this.editAssetModalEntitiesRequired = true;
		this.editContactModalEntitiesRequired = true;
		this.allowedTemplates = [];

		$scope.$watch<[{ [assetID: number]: string }, Models.IEntityRelationship[][]]>(() => <[{ [assetID: number]: string }, Models.IEntityRelationship[][]]>[this.assetTitleDictionary, this.contractRights.map(r => r.assetRels)],
			(newValue, oldValue) => {
				if (newValue != oldValue) {

					this.availAssetDictionary = {};
					if (!_.isEmpty(this.assetTitleDictionary) && _.any(this.contractRights)) {
						_.forEach(this.contractRights, (right) => {
							var availAssets: { [assetID: number]: string } = {};

							var allAssetIDs = _.keys(this.assetTitleDictionary).map((k) => _.parseInt(k)).filter((id) => _.isNumber(id) && !_.isNaN(id));
							var rightAssetIDs = right.assetRels.map((rel) => rel.childRecID);
							var availableIDs = _.difference<number>(allAssetIDs, rightAssetIDs);
							availableIDs.forEach((id) => {
								availAssets[id] = this.assetTitleDictionary[id];
							});
							this.availAssetDictionary[right.relationship.childRecID] = availAssets;
						});
					}
				}
			}, true);

		$scope.$watch(() => this.sharedData.contract != null ? this.sharedData.contract.charDataCollection.status.lockIndicator : 1,
			(newValue, oldValue) => {
				if (newValue > 0) {
					this.locked = true;
				}
				else {
					this.locked = false;
				}
			});

		eventService.on(Consts.Events.ContractRefreshAll, () => {
			if (this.initialized) {
				return this.RefreshAll();
			}
		});

		$scope.$watch(() => this.variesByCatalogService.selectedFields, (newValue, oldValue) => {
			this.hasVariesByCatalog = this.variesByCatalogService.checkForVariesByCatalog();
		}, true);

		$scope.$watch(() => this.variesByCatalogService.selectedDimension, (newValue, oldValue) => {
			this.hasVariesByCatalog = this.variesByCatalogService.checkForVariesByCatalog();
		}, true);

		$scope.$watch(() => this.selectedEntities, (newValue, oldValue) => {
			if (newValue != oldValue) {
				this.variesByCatalogSelectedAssets = {};
				this.selectedContacts = [];

				if (!_.isEmpty(this.selectedEntities[Consts.CharTypeIDs.user.toString()])) {
					this.selectedContacts = this.selectedEntities[Consts.CharTypeIDs.user.toString()];
				}

				let selectedCatalogItems: Models.IEntitySearchDoc[] = [];
				if (!_.isEmpty(this.selectedEntities[Consts.CharTypeIDs.property.toString()])) {
					selectedCatalogItems = this.selectedEntities[Consts.CharTypeIDs.property.toString()]
					selectedCatalogItems.forEach(assetID => {
						if (this.assetTitleDictionary[assetID.recordID] == null) {
							//Then this is an implicit relationship that we do not have info for, go get it
							this.entityService.getEntityRecord(assetID.entityID)
								.then((result) => {
									this.variesByCatalogSelectedAssets[assetID.recordID] = result.title;
								});
						}
						else {
							this.variesByCatalogSelectedAssets[assetID.recordID] = this.assetTitleDictionary[assetID.recordID];
						}
					});
				}

				if (this.selectedContacts.length > 0 || selectedCatalogItems.length > 0) {
					this.editAssetModalEntitiesRequired = false;
				}
				else {
					this.editAssetModalEntitiesRequired = true;
				}
			}
		}, true);

		$scope.$watch(() => this.rrpSelectedCatalogItems, (newValue, oldValue) => {
			if (newValue != oldValue) {
				this.rrpHasInvalidCatalog = false;
				//check if any of the rights templates don't have the selected catalogs items as a valid template
				for (let i = 0; i < this.rrpSelectedCatalogItems.length && !this.rrpHasInvalidCatalog; i++) {
					for (let key in this.rrpCatalogTemplates) {
						if (this.rrpCatalogTemplates[key].indexOf(this.rrpSelectedCatalogItems[i].templateID) < 0) {
							this.rrpHasInvalidCatalog = true;
						}
					}
				};
			}
		});
	}

	Init(contractID: string) {
		this.contractID = contractID;
		this.RefreshDetails();

		this.relationshipCharTypeIDs = [Consts.CharTypeIDs.property, Consts.CharTypeIDs.user];

		this.aclService.loadActivityAcls()
			.then((acls) => {
				this.canEdit = Utils.AclUtil.hasWriteAccess(acls, Consts.Acl.Activities._Site._Mod4.Rights);
			});
	}

	RefreshAll(): ng.IPromise<any> {
		this.notifyService.startProgress();
		var promise1 = this.RefreshValidation();
		this.forceRefresh = true;
		return this.$q.all([promise1])
			.then(() => {
				this.initialized = true;
			})
			.finally(() => {
				this.notifyService.endProgress();
			});
	}

	private LoadDataDefaults(templateID: number) {
		return this.entityService.getAssociatedTemplatesDefaults(Consts.CharTypeIDs.transaction, templateID, Consts.CharTypeIDs.right)
			.then((res) => {
				this.rightsDataDefaults = res.dataDefaultSets;
			});
	}

	//RRP
	private LoadRRP() {
		//RRP profile loading
		//Check if the user has write and create access for rights
		//if so, load in the rrp profiles
		var rrpAcls = Utils.AclUtil.getDataEntityAcl(Consts.CharTypeIDs.right);
		this.showRelativeRightsProfiles = Utils.AclUtil.hasCreateAccess(this.aclService.acls, rrpAcls) && Utils.AclUtil.hasWriteAccess(this.aclService.acls, rrpAcls);
		if (this.showRelativeRightsProfiles) this.GetProfiles();
	}

	ShowRelativeRightsProfileModal(profile: Models.IEntitySearchDoc) {
		this.targetRRP = profile;
		this.UnselectAllCatalogs();
		this.notifyService.startProgress();
		this.rrpHasInvalidRightset = false;
		//Check if profile has any rightsets that are not permitted on the deal 
		//get list of what right templates are allowed on deal
		this.entityService.getAssociatedTemplatesForTemplate(Consts.CharTypeIDs.transaction, this.contractTemplateID, Consts.CharTypeIDs.right)
			.then((result2) => {
				let validRightsTemplates = result2.filter(ct => Utils.AclUtil.hasCreateAccess(this.aclService.acls, ct.acl));
				var profileRecID = Utils.IdBuilder.splitEntityID(profile.entityID).recID;
				//get associated right templates on rrp profile and check against what templates are allowed on deal	
				this.entityConfigService.getMockRightsByTemplate(profileRecID, 0, 1)
					.then((results) => {
						this.rrpRightsTemplates = results.data.groups;
						//check if all the rights templates on the RRP is valid for the deal
						for (var i = 0; i < this.rrpRightsTemplates.length && !this.rrpHasInvalidRightset; i++) {
							this.rrpHasInvalidRightset = _.filter(validRightsTemplates, t => t.templateID == this.rrpRightsTemplates[i].templateID).length == 0;
						}
						for (var i = 0; i < this.rrpRightsTemplates.length && this.userCanCreateAllRightsOnRRP; i++) {
							var rrpAcls = Utils.AclUtil.getDataEntityAcl(Consts.CharTypeIDs.right, this.rrpRightsTemplates[i].templateMetaData.template.templateGroupID, this.rrpRightsTemplates[i].templateMetaData.template.templateID);
							this.userCanCreateAllRightsOnRRP = Utils.AclUtil.hasCreateAccess(this.aclService.acls, rrpAcls) && Utils.AclUtil.hasWriteAccess(this.aclService.acls, rrpAcls);
						};
					}).finally(() => {
						//open error modal if RRP has templates that cannot be used on the deal
						if (this.rrpHasInvalidRightset) {
							this.showRRPErrorModal = true;
							this.notifyService.endProgress()
						}
						//otherwise open RRP create modal
						else {
							this.GetValidCatalogTemplates()
								.then(() => {
									this.showAssociateRRPModal = true;
									this.notifyService.endProgress()
								});
						}
					});
			});

	}

	GetValidCatalogTemplates(): ng.IPromise<any> {
		this.rrpCatalogTemplates = [];
		//get catalog templates that are valid for selected RRP			
		this.notifyService.startProgress();
		let promises: ng.IPromise<any>[] = [];
		this.allowedTemplates = [];
		_.forEach(this.rrpRightsTemplates, (rightTemplate) => {
			promises.push(this.entityService.getAssociatedTemplatesForTemplate(Consts.CharTypeIDs.right, rightTemplate.templateID, Consts.CharTypeIDs.property)
				.then((result) => {
					let validCatalogs = result.filter(ct => Utils.AclUtil.hasCreateAccess(this.aclService.acls, ct.acl));
					let templateIDs = validCatalogs.map(c => c.templateID);
					_.forEach(templateIDs, t => {
						if (!_.any(this.allowedTemplates, at => at == t)) {
							this.allowedTemplates.push(t);
						}
					});
					this.rrpCatalogTemplates[rightTemplate.templateID] = templateIDs;
				}));
		});

		return this.$q.all(promises)
			.then(() => {
				this.notifyService.endProgress();
			});
	}

	ApplyRRPToCatalogItems() {
		let selectedEntitiesRecIDs = []
		if (this.rrpSelectedCatalogItems.length > 0) {
			for (let item of this.rrpSelectedCatalogItems) {
				selectedEntitiesRecIDs.push(item.recordID);
			}
			let contractRecID = Utils.IdBuilder.splitEntityID(this.contractID).recID;
			this.entityService.applyRelativeRightsProfileFromDeal(this.targetRRP.recordID, this.rrpAdditionalOption, contractRecID, selectedEntitiesRecIDs)
				.then((result) => {
					this.showAssociateRRPModal = false;
					alert("The Relative Rights Profile is being applied. You will receive an email notification once the job completes and all records have been made visible (re-indexed).  In the meantime, you can leave this page and continue working elsewhere.");
				}, this.notifyService.errorResponseHandler)
				.finally(() => {
					this.notifyService.endProgress();
				});
		}
	}

	//Get RRP profiles code taken from relative-rights-profiles-controller.ts
	GetProfiles() {
		this.notifyService.startProgress();
		var request: Models.IAdvancedSearchModel = {
			charTypeID: Consts.CharTypeIDs.mock,
			searchGroups: [],
			keywords: "",
			page: 1,
			rowCount: 100
		};

		this.searchService.advancedSearch(request)
			.then((results) => {
				this.relativeRightsProfiles = _.sortBy(_.filter(results.documents, d => d.templateID == 1), p => p.recordID);
			})
			.finally(() => {
				this.notifyService.endProgress();
			});
	}
	RefreshDetails(): ng.IPromise<any> {
		this.notifyService.startProgress();

		var promise1 = this.sharedData.RefreshContract(this.contractID)
			.then((result) => {
				this.contractTemplateID = result.record.templateID;
				this.LoadDataDefaults(result.record.templateID);
				this.LoadRRP();
				return this.entityService.getAssociatedTemplatesForTemplate(Consts.CharTypeIDs.transaction, result.record.templateID, Consts.CharTypeIDs.right)
					.then((result2) => {
						this.rightTemplates = result2.filter(ct => Utils.AclUtil.hasCreateAccess(this.aclService.acls, ct.acl));
						this.templateColors = result2.reduce(function (map, obj) {
							map[obj.templateID] = obj.visualization;
							return map;
						}, {});
					});
			}, () => {
				this.notifyService.notifyError("Contract Not Found");
			});


		this.loadingAssets = true;

		var contractRecID = Utils.IdBuilder.splitEntityID(this.contractID).recID;
		var promise2 = this.contractService.getContractAssetTitles(contractRecID)
			.then((result) => {
				this.assetTitleDictionary = result.data;

				_.keys(result.data).forEach(key => {
					var value = result.data[key];

					this.assetTitlesSorted.push({ key: _.parseInt(key), value: value });
				});

				this.loadingAssets = false;
				this.showRightAssets = true;
			});

		return this.$q.all([promise1, promise2])
			.finally(() => {
				this.notifyService.endProgress();
			});
	}

	RefreshValidation(): ng.IPromise<any> {
		return this.eventService.call(Consts.Events.ValidateEntity);
	}

	Cancel(entity: Models.IEntityCharDataPair) {
		this.notifyService.startProgress();
		this.entityService.getEntityCharData(entity.record.id)
			.then((result) => {
				entity.charDataCollection = result;
			})
			.finally(() => {
				this.notifyService.endProgress();
			});
	}

	Save(entity: Models.IEntityCharDataPair, isValid: boolean) {
		if (isValid) {
			this.notifyService.startProgress();
			this.entityService.saveCharData(entity.record.id, entity.charDataCollection.charDatas)
				.then(() => {
					this.forceRefresh = true;
				}, this.notifyService.errorResponseHandler)
				.then(() => {
					this.notifyService.notifySuccess("Save Successful");
					this.RefreshValidation();
				})
				.finally(() => {
					this.notifyService.endProgress();
				});

		}
	}

	/*
	 * Opens the modal for creating a new RightSet
	 * @param template the template of the new rightset
	 * @param $event the click event of the <a> tag
	 */
	NewRight(template: Models.ICharacteristicTemplate, $event: ng.IAngularEvent) {
		$event.preventDefault();

		this.relationshipRequired = {};
		_.forEach(this.relationshipCharTypeIDs, (relCharTypeID) => {
			this.entityConfigService.getRecordAssociationCharacteristicTemplateRequired(Consts.CharTypeIDs.right, template.templateID, relCharTypeID)
				.then((res) => {
					if (res && res.charTypeID) {
						this.relationshipRequired[relCharTypeID.toString()] = true;
					}
				})
		})

		var divID = Utils.IdBuilder.splitEntityID(this.contractID).divID;
		var templateID = Utils.IdBuilder.buildTemplateID(divID, Consts.CharTypeIDs.right, template.templateID);

		this.notifyService.startProgress();
		this.entityService.getEmptyEntityCharData(templateID)
			.then((result) => {
				this.newRightCharDataCollection = result;
				this.variesByCatalogService.clearSavedFields();
				this.UnselectAllCatalogs();
				this.rightSetModalOpen = true;
			})
			.finally(() => {
				this.notifyService.endProgress();
			});
	}

	/*
	 * Creates the new RightSet from the modal VCG
	 * @param charDataCollection chardata from the modal VCG
	 * @isValid the validity of the form containing the VCG
	 */
	CreateRight(charDataCollection: Models.ICharDataCollection, isValid: boolean) {
		if (isValid) {
			this.notifyService.startProgress();

			var templateID = Utils.IdBuilder.buildTemplateID(charDataCollection.templateMetaData.divID, charDataCollection.templateMetaData.charTypeID, charDataCollection.templateMetaData.templateID);
			var parentID = this.contractID;

			let selectedAssets = this.selectedEntities[Consts.CharTypeIDs.property.toString()];
			var selectedAssetRecIDs = selectedAssets != null ? selectedAssets.map(e => e.recordID) : [];
			var selectedContactRecIDs = this.selectedEntities[Consts.CharTypeIDs.user.toString()] != null ? this.selectedEntities[Consts.CharTypeIDs.user.toString()].map(e => e.recordID) : [];

			if (selectedAssetRecIDs.length > 20) {
				this.notifyService.notifyInfo("You've selected more than 20 associated entities. This may take a few minutes to create.");
			}

			this.contractService.createRightSet(templateID, parentID, charDataCollection.charDatas, selectedAssetRecIDs, selectedContactRecIDs)
				.then((result) => {
					if (result.success) {
						this.notifyService.notifySuccess("Rights Created");
					} else {
						this.notifyService.notifyError("Error creating Rights");
					}
				})
				.then(() => {
					this.newRightCharDataCollection = null;
					this.rightSetModalOpen = false;
					this.RefreshValidation();
				})
				.finally(() => {
					this.sharedData.RefreshContract(this.contractID);
					this.forceRefresh = true;
					this.notifyService.endProgress();
				});
		}
	}

	/*
	 * Used with the Varies by Catalog option.  Creates multiple RightSets (one per Catalog item)
	 * using a modal to allow for "bulk" entry
	 */
	QuickRightsEntry(charDataCollection: Models.ICharDataCollection, isValid: boolean) {
		if (isValid) {
			this.notifyService.startProgress();
			let count = 0;
			_.forOwn(this.selectedEntities, (values, key) => {
				count += values.length;
			});
			if (count > 20) {
				this.$window.confirm("Please be patient while we calculate your Rights. It may take us a minute to save you an hour.");
			}
			this.variesByCatalogOpenModal = true;

			this.variesByCatalogParentTemplateID = Utils.IdBuilder.buildTemplateID(charDataCollection.templateMetaData.divID, charDataCollection.templateMetaData.charTypeID, charDataCollection.templateMetaData.templateID);
			this.variesByCatalogCharDataCollection = _.cloneDeep(charDataCollection);

			this.rightSetModalOpen = false;
			this.notifyService.endProgress();
		}
	}

	CancelModal() {
		this.rightSetModalOpen = false;
		this.variesByCatalogService.clearSavedFields();
	}

	private UnselectAllCatalogs() {
		this.selectedEntities = {};
	}

	CopyDataDefaultSet(dataDefault: Models.IDataDefaultSet, entityID: any) {
		if (dataDefault.hasConfigurationError) {
			alert("This Rights Profile has Records with Templates that aren't configured for this Deal Template.");
			return;
		}

		var id: number = -1;
		var charTypeID: number = -1;
		if (parseInt(entityID)) {
			id = entityID;
		} else {
			id = Utils.IdBuilder.splitEntityID(entityID).recID;
			charTypeID = Utils.IdBuilder.splitEntityID(entityID).charTypeID;
		}
		this.notifyService.startProgress();

		this.entityService.copyDataDefaultSet(dataDefault.id, charTypeID, id, true)
			.then((result) => {
				this.newDataDefaultSetEntityIDs = [];
				if (result.success) {
					_.forEach(result.data, (r: string) => {
						this.newDataDefaultSetEntityIDs.push(r);
					});
				}

				this.$timeout(() => {
					this.forceRefresh = true;
				}, 500);
			})
			.finally(() => {
				this.notifyService.endProgress();
			});
	}

	DeleteDataDefaultSet(setID: string) {
		const rightsDataLabel = _.find(this.rightsDataDefaults, (rightsDefault) => { return rightsDefault.id === setID }).label;
		if (this.$window.confirm(`Are you sure you want to delete the ${rightsDataLabel} Rights Profile?`)) {
			this.notifyService.startProgress();

			this.entityService.deleteDataDefaultSet(setID)
				.then((res) => {
					var index = -1;
					for (var i = 0; i < this.rightsDataDefaults.length; i++) {
						if (this.rightsDataDefaults[i].id == setID) {
							index = i;
							break;
						}
					}

					if (index > -1) {
						this.rightsDataDefaults.splice(index, 1);
					}
				})
				.finally(() => {
					this.notifyService.endProgress();
				});
		}
	}

	DataChanged(parentEntityID: string) {
		if (!_.isEmpty(parentEntityID)) {
			this.sharedData.RefreshContract(parentEntityID);
		}
	}
}
